import { useTikTokAccess } from "@/hooks/useTikTokAccess";

/**
 * Whether the dashboard's TikTok section exists for this brand. It does as
 * soon as the brand has access to the module: before a connection it shows
 * the connect card, after one the analytics. Shared by the section and the
 * sticky nav (react-query dedupes the status fetch by key).
 */
export function useTikTokSectionVisible(): boolean {
  const access = useTikTokAccess();
  return access.enabled;
}
